import { Injectable, type Signal, signal } from '@angular/core';
import { AuthenticationStrategy } from './authentication-strategy.interface';

@Injectable({
    providedIn: 'root',
})
export class NoopAuthenticationStrategy implements AuthenticationStrategy {
    private readonly _isAuthenticated = signal<boolean>(false);

    public get isAuthenticated(): Signal<boolean> {
        return this._isAuthenticated;
    }

    public async setup(): Promise<void> {
        // No operation - never authenticated
    }

    public login(): undefined {
        // No operation - never authenticated
    }

    public async logout(): Promise<void> {
        // No operation - never authenticated
    }

    public getToken(): string | undefined {
        return undefined;
    }
}
